export default __webpack_public_path__ + "static/media/search.0c868fe9.svg";